module.exports = __webpack_public_path__ + "img/IMG_8981_L_WoodMatted.a6326c9f.jpg";